<template>
  <!-- <div class=""></div> -->
  <div class="miyi-frame">
    <iframe
      :src="src"
      width="100%"
      style="position: relative;top: -84px;height: calc(100% + 88px);"
    ></iframe>
  </div>
</template>

<script>
import monitors from '@/assets/monitors.json'

export default {
  props: {
    height: Number,
    width: Number
  },
  computed: {
    src() {
      const monitor = monitors.find(m => +m.companyId === +this.companyId)
      return monitor ? monitor.url : ''
    }
  }
}
</script>

<style lang="css" scoped>
.miyi-frame {
  overflow: hidden;
  height: 100%;
}
</style>
